import Factory from '../utils/factory'
import Fee from './fee'

export default Factory({
  value: null,
  fixed: true,
  bidUrl: null,
  jointDebt: null,
  jointDebtInterestRate: null,
  deposit: null,
  fee: Fee(),
  type: 'sale',
})
